import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=59ea2d9f&scoped=true"
import script from "./ActivityForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=59ea2d9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ea2d9f",
  null
  
)

export default component.exports